export default __webpack_public_path__ + "static/media/thumbnail.f3b5e125.svg";